import { createAction } from '@reduxjs/toolkit'

export enum Field {
  CURRENCY_A = 'CURRENCY_A',
  CURRENCY_B = 'CURRENCY_B',
}

export enum Bound {
  LOWER = 'LOWER',
  UPPER = 'UPPER',
}

export enum PresetRange {
  NARROW = 'NARROW',
  COMMON = 'COMMON',
  WIDE = 'WIDE',
  FULL = 'FULL',
  CUSTOM = 'CUSTOM',
}

export const typeInput = createAction<{ field: Field; typedValue: string; noLiquidity: boolean }>(
  'mintV3/typeInputMint'
)
export const typeStartPriceInput = createAction<{ typedValue: string }>('mintV3/typeStartPriceInput')
export const resetMintState = createAction<void>('mintV3/resetMintState')
export const setFullRange = createAction<void>('mintV3/setFullRange')

export const typeLeftRangeTick = createAction<{ tick: number | undefined }>('mintV3/typeLeftRangeTick')
export const typeRightRangeTick = createAction<{ tick: number | undefined }>('mintV3/typeRightRangeTick')

export const typeLeftRangeInput = createAction<{ typedValue: string }>('mintV3/typeLeftRangeInput')
export const typeRightRangeInput = createAction<{ typedValue: string }>('mintV3/typeRightRangeInput')

export const setPresetRange = createAction<{ preset: PresetRange }>('mintV3/setPresetRange')
export const setPresetTicks = createAction<{
  preset: PresetRange
  leftTick?: number
  rightTick?: number
}>('mintV3/setPresetTicks')
